import React from "react";
import { X } from "react-feather";
import { connect } from "react-redux";
import { dismissServerMessage } from "./ServerMessageActions";

class ServerMessages extends React.Component {
  componentDidUpdate({ messages, errors, dispatch }) {
    if (messages.length || errors.length) {
      const firstMessage = [...messages, ...errors][0];
      setTimeout(() => dispatch(dismissServerMessage(firstMessage)), 6000);
    }
  }

  dismiss = (key) => () => {
    this.props.dispatch(dismissServerMessage(key));
  };

  render() {
    const { messages, errors } = this.props;
    if (!messages.length && !errors.length) return null;
    return (
      <div className="server-messages">
        {errors &&
          errors.length > 0 &&
          errors
            .filter(
              (value) => value !== undefined && value !== null && value !== ""
            )
            .map((error) => (
              <div key={error} onClick={this.dismiss(error)} className="error">
                {error}
                {/* <i className="icon-close" /> */}
                <X role="button" style={{ float: "right" }} />
              </div>
            ))}
        {messages &&
          messages.length > 0 &&
          messages
            .filter(
              (value) => value !== undefined && value !== null && value !== ""
            )
            .map((message) => (
              <div key={message} onClick={this.dismiss(message)}>
                {message}
                {/* <i className="icon-close" /> */}
                <X role="button" style={{ float: "right" }} />
              </div>
            ))}
      </div>
    );
  }
}

const mapStateToProps = ({ serverMessages, errors }) => ({
  messages: serverMessages,
  errors: errors.serverErrors,
});

export default connect(mapStateToProps)(ServerMessages);
